import {on} from './util/event'

  var
      shareEventName = 'share.kiosk.audioEpisode',

      likeEventName = 'like.kiosk.audioEpisode',
      dislikeEventName = 'dislike.kiosk.audioEpisode'
  ;



  on(shareEventName, function(e) {
    var  eventData = e.detail,
        id = eventData.id,
        url = eventData.url;
      if(navigator.share){
        navigator.share({
          url: url
        })
      }
  });

on(likeEventName, function(e) {
  var  eventData = e.detail,
       id = eventData.id,
       url = eventData.url,
       $article = $('body').find('.audio-episode[data-item-id="' + id + '"]'),
       like = parseInt($article.data('like')),
       $btnLike = $article.find('.btn-icon.like'),
       $btnDislike = $article.find('.btn-icon.dislike');

  $btnLike.prop('disabled', true);
  $btnDislike.prop('disabled', true);
  $.ajax({
    url: url,
    type: like === 1 ? 'DELETE' : 'PUT',
    success: function (data) {
      if (data.result) {
        $article.data('like', data.like);
        $btnLike[(data.like === 1 ? 'add' : 'remove') + 'Class']('custom-active');
        $btnDislike[(data.like === -1 ? 'add' : 'remove') + 'Class']('custom-active');
      }
    },
    error: function () {
    },
    complete: function () {
      $btnLike.prop('disabled', false);
      $btnDislike.prop('disabled', false);
    }
  });

})

on(dislikeEventName, function(e) {
  var  eventData = e.detail,
       id = eventData.id,
       url = eventData.url,
       $article = $('body').find('.audio-episode[data-item-id="' + id + '"]'),
       like = parseInt($article.data('like')),
       $btnLike = $article.find('.btn-icon.like'),
       $btnDislike = $article.find('.btn-icon.dislike');

  $btnLike.prop('disabled', true);
  $btnDislike.prop('disabled', true);
  $.ajax({
    url: url,
    type: like === -1 ? 'DELETE' : 'PUT',
    success: function (data) {
      if (data.result) {
        $article.data('like', data.like);
        $btnLike[(data.like === 1 ? 'add' : 'remove') + 'Class']('custom-active');
        $btnDislike[(data.like === -1 ? 'add' : 'remove') + 'Class']('custom-active');
      }
    },
    error: function () {
    },
    complete: function () {
      $btnLike.prop('disabled', false);
      $btnDislike.prop('disabled', false);
    }
  });

});


  const audioEpisode = {

    shareEvent: shareEventName,
    likeEvent: likeEventName,
    dislikeEvent: dislikeEventName,

  };

  export default audioEpisode;
